<template>
	<div class="earlyWarning">
		<el-row class="layout-div" v-show="pageId === '0'">
			<el-col :span="18" class="layout-left-div">
				<div class="layout-left-top boxBlock">
					<el-row class="row-bottom">
						<el-col :span="20"><early-time @changeTime="changeTime" :selDays="query.days"></early-time></el-col>
						<el-col :span="4" class="textR" style="height: 40px;line-height: 34px;">
							<el-button type="primary" style="margin-right: 20px" class="thmeBackColor borderColor btnclass" size="mini" @click="filterSearch">查询</el-button>
							<span class="curpointer" @click.stop="collectionDepot" v-if="ifBack">
								<i class="iconfont iconhuishouzhan hovertext huisshou-icon"></i>
							</span>
						</el-col>
					</el-row>
					<el-row class="row-bottom">
						<el-col :span="14"><filter-status :list="meitis" :defaultValue="query.area" :themName="'媒体区域'" @changeVal="changemeiti"></filter-status></el-col>
						<el-col :span="10"><filter-status :list="paixus" :defaultValue="query.sort" :themName="'信息排序'" @changeVal="changepaixu"></filter-status></el-col>
					</el-row>
					<el-row class="">
						<el-col :span="24"><meiti-type-warning :defaultValue="meitiCheckList" :themName="'媒体类型'" @changeMeiti="changeMeitiType"></meiti-type-warning></el-col>
					</el-row>
				</div>
				<div class="layout-left-bottom boxBlock">
					<el-row class="actionRow">
						<el-col :span="8" class="list-flex-col">
							<el-checkbox v-model="checkedAll" @change="checkedAllChange">全选</el-checkbox>

							<!-- <span class="iconimg piliangdaochu curpointer" @click.stop="batchExport"><div class="tooltip">选择导出</div></span> -->
							<span class="iconimg iconfont  iconxuanzedaochu curpointer action-icon hovertext"@click.stop="batchExport"><div class="tooltip">选择导出</div></span>

						<!-- 	<span class="iconimg quanbudaochu curpointer" @click.stop="allExport"><div class="tooltip">全部导出</div></span> -->
							<span class="iconimg iconfont  iconqunbudaochu curpointer action-icon hovertext" @click.stop="allExport"><div class="tooltip">全部导出</div></span>

							<!-- <span class="iconimg shanchu curpointer" @click.stop="batchDel"><div class="tooltip">删除</div></span> -->
							<span class="iconimg shanchu1 iconfont iconsmallshanchu curpointer action-icon hovertext" @click.stop="batchDel"><div class="tooltip">删除</div></span>
						</el-col>
						<el-col :span="4" class="textC">
							<div v-show="totalPage>0">
								<span class="dire dingbuleft hoverborder curpointer" @click="clickPrevious"></span>
								<span class="direshuzi">{{ query.pageNo }}/{{ totalPage }}</span>
								<span class="dire dingburight hoverborder curpointer" @click="clickNext"></span>
							</div>
						</el-col>
						<el-col :span="12" class="textR">
							<el-input placeholder="请输入关键字" v-model.trim="inputkey2" class="input-with-select searchinput">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
								<el-button slot="append" type="primary" class="thmeBackColor borderColor searchbtn" @click="btnSearch">搜索</el-button>
							</el-input>
						</el-col>
					</el-row>
					<div class="line mt"></div>
					<el-collapse-transition>
						<div class="news-prop curpointer" v-show="haveNews" @click="hideNewsProps">
							<div class="news-info">
								已有
								<span class="nums">{{newsNum}}</span>
								条新的数据，点击可更新
							</div>
						</div>
					</el-collapse-transition>
					<el-row v-loading="dataloading" element-loading-spinner="el-icon-loading" class="table-minH" :class="{ 'data-loading': dataloading }">
						<ul class="listul" v-if="total !== 0">
							<li class="lis" v-for="item in yuqingList" :key="item.id">
								<el-row class="lisrow" :class="{ active: item.ischeckd }">
									<el-col :span="2" class="checkCol">
										<div class="check-div"><el-checkbox v-model="item.ischeckd" @change="singelChecked"></el-checkbox></div>
									</el-col>
									<el-col :span="22" class="contentCol">
										<el-row class="title-row">
											<el-col :span="20" class="title textOverOneLine titleClass ">
												<a :href="item.url" v-html="item.titleTag" class="hovertext" target="_blank"></a>
											</el-col>
											<el-col :span="4" class="textL">
												<!--<span ><img src="../../assets/img/earlyWarning/buxin.png" alt="" v-if="item.xingji === 0"></span>-->
												<span>
													<!-- <img src="../../assets/img/earlyWarning/kongxin1.png" alt="" v-if="item.warnDegree === 1" /> -->
													<i class="iconfont iconxing1 li-action-icon " style="font-size: 22px;color:#ff9600;" v-if="item.warnDegree === 1"></i>
													</span>
												<span>
													<i class="iconfont iconxing2  li-action-icon" style="font-size: 22px;color:#ff9600;" v-if="item.warnDegree === 2"></i>
													<!-- <img src="../../assets/img/earlyWarning/banxin1.png" alt="" v-if="item.warnDegree === 2" /> -->
													</span>
												<span>
													<i class="iconfont iconxing3  li-action-icon" style="font-size: 22px;color:#ff9600;" v-if="item.warnDegree === 3"></i>
													<!-- <img src="../../assets/img/earlyWarning/manxin1.png" alt="" v-if="item.warnDegree === 3" /> -->
													</span>
											</el-col>
										</el-row>
										<el-row class="textOverTwoLine zhaoyaoClass zhaoyaoCol" v-html="item.contentTag"></el-row>
										<el-row class="newInfos zhaoyaoClass" type="flex" justify="space-between">
											<el-col :span="16" class="textL">
												<el-row>
													<el-col :span="11">
														<!-- <img src="../../assets/img/monitoring/list/fbsjicon.png" alt="" /> -->
														<i class="iconfont icontime list-time-icon"></i>
														发表时间: {{ item.pageTime }}
													</el-col>
													<el-col :span="5" class="textOverOneLine">
														<!-- <img src="../../assets/img/monitoring/list/laiyuan.png" alt="" /> -->
														<i class="iconfont iconlaiyuan list-time-icon" style="font-size: 22px;"></i>
														来源: {{ item.websiteName }}
													</el-col>
													<el-col :span="8" class="textOverOneLine" v-show="item.auth != null">
														<img src="../../assets/img/earlyWarning/zj.png" alt="" />
														作者: {{ item.auth }}
													</el-col>
												</el-row>
											</el-col>
											<el-col :span="8" class="textR fuzhiline">
												<span class="iconimg  curpointer" v-if="$cookies.get('userInfo').custId==174" @click.stop="jiaoban(item)">
													<i class="iconfont iconshanbao hovertext li-action-icon"></i>
													<div class="tooltip">舆情交办</div>
												</span>
												<span class="iconimg  curpointer" @click.stop="detailContent(item)">
													<i class="iconfont iconchakanzhengwen hovertext li-action-icon"></i>
													<div class="tooltip">查看正文</div>
												</span>
												<span class="iconimg fzyq curpointer">
													<i class="iconfont iconfuzhiyuqing hovertext li-action-icon"></i>
													<div class="fuzhi borderColor">
														<div class="fuzhili hovertext curpointer" @click.stop="copy(item, 1)">复制舆情</div>
														<div class="fuzhili hovertext curpointert" @click.stop="copy(item, 2)">复制链接</div>
														<div class="arrow borderBottom"></div>
													</div>
												</span>

												<span class="iconimg  curpointer" @click.stop="singlepublicReport(item)">
													<i class="iconfont iconyuqingshangbao hovertext li-action-icon"></i>
													<div class="tooltip">舆情上报</div></span>
												<span class="iconimg  pxdz curpointer">
													<i class="iconfont iconxing1 hovertext li-action-icon" style="font-size: 22px;"></i>
													<div class="fuzhi borderColor">
														<el-row class="xings">
															<el-col :span="8" v-if="item.warnDegree != 0" class="textC">
																<span class="curpointer" @click.stop="biaoxing(0, item)">
																	<i class="iconfont iconxing0  li-action-icon" style="font-size: 22px;color:#ff9600;"></i>
																</span>
															</el-col>
															<el-col :span="8" v-if="item.warnDegree != 1" class="textC">
																<span class="curpointer" @click.stop="biaoxing(1, item)">
																	<i class="iconfont iconxing1 li-action-icon " style="font-size: 22px;color:#ff9600;"></i>
																</span>
															</el-col>
															<el-col :span="8" v-if="item.warnDegree != 2" class="textC">
																<span class="curpointer" @click.stop="biaoxing(2, item)">
																	<i class="iconfont iconxing2  li-action-icon" style="font-size: 22px;color:#ff9600;"></i>
																</span>
															</el-col>
															<el-col :span="8" v-if="item.warnDegree != 3" class="textC">
																<span class="curpointer" @click.stop="biaoxing(3, item)">
																	<i class="iconfont iconxing3  li-action-icon" style="font-size: 22px;color:#ff9600;"></i>
																</span>
															</el-col>
														</el-row>

														<div class="arrow1 borderBottom"></div>
													</div>
												</span>
												<span class="iconimg shanchu1 curpointer" @click.stop="singleDel(item)">
													<i class="iconfont iconshanchu hovertext li-action-icon"></i>
													<div class="tooltip">删除</div></span>
											</el-col>
										</el-row>
									</el-col>
								</el-row>
							</li>
						</ul>
						<div class="nodata" v-if="total === 0">
							<div class="nodataImg">
								<div class="textC "><!-- <img src="../../assets/img/earlyWarning/wsj_07.png" alt="" /> -->
								<i class="iconfont iconwushuju wushuju-icon"></i></div>
								<div class="textC font14 nodataText">暂无数据！</div>
							</div>
						</div>
					</el-row>

					<div class="line mb" v-if="total > 0"></div>
					<el-row class="listFooter" v-if="total > 0">
						<el-col :span="8" class="list-flex-col">
							<el-checkbox v-model="checkedAll" @change="checkedAllChange">全选</el-checkbox>
							<!-- <span class="iconimg piliangdaochu curpointer" @click.stop="batchExport"><div class="tooltip">选择导出</div></span> -->
								<span class="iconimg iconfont  iconxuanzedaochu curpointer action-icon hovertext"@click.stop="batchExport"><div class="tooltip">选择导出</div></span>

							<!-- 	<span class="iconimg quanbudaochu curpointer" @click.stop="allExport"><div class="tooltip">全部导出</div></span> -->
								<span class="iconimg iconfont  iconqunbudaochu curpointer action-icon hovertext" @click.stop="allExport"><div class="tooltip">全部导出</div></span>

								<!-- <span class="iconimg shanchu curpointer" @click.stop="batchDel"><div class="tooltip">删除</div></span> -->
								<span class="iconimg shanchu1 iconfont iconsmallshanchu curpointer action-icon hovertext" @click.stop="batchDel"><div class="tooltip">删除</div></span>
						</el-col>
						<el-col :span="16" class="textR flexcol">
							<el-pagination
								background
								:current-page="query.pageNo"
								@current-change="handleCurrentChange"
								layout="total,prev, pager, next,jumper"
								:total="total"
								:pageSize="query2.pageSize"
								:pager-count="5"
							></el-pagination>
							<el-button class="go-btn">GO</el-button>
						</el-col>
					</el-row>
				</div>
			</el-col>
			<el-col :span="6" class="layout-right-div" :class="{ isfixbottom: rightFixedbottom }">
				<!--  -->
				<div class="fixBlock" :class="{ isfixbottom: rightFixedbottom }">
					<!--<div class="layout-right-block layout-right-top boxBlock">
						<div class="titleRow">
							<img src="../../assets/img/earlyWarning/re.png" alt="" />
							省内热点
						</div>
						<div class="line"></div>
						<div class="content">
							<ul v-show="provinceNewsList.length > 0">
								<li class="lirow" v-for="(item, index) in provinceNewsList" :key="item.id">
									<el-row>
										<el-col :span="4" class="dot">{{ index + 1 }}</el-col>
										<el-col :span="20" class="col2 textOverOneLine">
											<a :href="item.url" target="_blank" class="hovertext">{{ item.title }}</a>
										</el-col>
									</el-row>
								</li>
							</ul>

							<div class="nodata" v-show="provinceNewsList.length == 0">
								<div class="nodataImg">
									<div class="textC ">
										&lt;!&ndash; <img src="../../assets/img/earlyWarning/wsj_07.png" alt="" /> &ndash;&gt;
										<i class="iconfont iconwushuju wushuju-icon"></i>
										</div>
									<div class="textC font14 nodataText">暂无数据！</div>
								</div>
							</div>
						</div>
					</div>-->
					<div class="layout-right-block layout-right-bottom boxBlock">
						<div class="titleRow">
							<img src="../../assets/img/earlyWarning/re.png" alt="" />
							国内热点
						</div>
						<div class="line"></div>
						<div class="content">
							<ul v-show="countryNewsList.length > 0">
								<li class="lirow" v-for="(item, index) in countryNewsList" :key="item.id">
									<el-row>
										<el-col :span="4" class="dot">{{ index + 1 }}</el-col>
										<el-col :span="20" class="col2 textOverOneLine">
											<a :href="item.url" target="_blank" class="hovertext">{{ item.title }}</a>
										</el-col>
									</el-row>
								</li>
							</ul>

							<div class="nodata" v-show="countryNewsList.length == 0">
								<div class="nodataImg">
									<div class="textC ">
										<i class="iconfont iconwushuju wushuju-icon"></i>
										<!-- <img src="../../assets/img/earlyWarning/wsj_07.png" alt="" /> --></div>
									<div class="textC font14 nodataText">暂无数据！</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>

		<confirm-prop2 @sucess="confirmSucess" ref="confirmProp2"></confirm-prop2>
		<tool-tip-prop2 ref="toolTipProp2"></tool-tip-prop2>
		<closed-prop2 ref="closedProp2"></closed-prop2>
		<report-loading ref="reportLoading"></report-loading>
		<warning-depot ref="warningDepot" :index="index"></warning-depot>
		<confirm-warning-prop2 ref="confirmWarningProp2"></confirm-warning-prop2>
		<warning-prop ref="warningProp"></warning-prop>

		<warning-details-page v-if="pageId === '2'"></warning-details-page>
		<report-news ref="reportNews"></report-news>
		<closed-prop2 ref="closedProp2"></closed-prop2>
		<jiaobanDialog v-if="showJBdialog" ref="jiaobanRef" @dialogClose="dialogClose" ></jiaobanDialog>
	</div>
</template>

<script>
import EarlyTime from '@/components/EarlyTime.vue';
import FilterStatus from '@/components/filterStatus.vue';
import MeitiType2 from '@/components/MeitiType2.vue';
import WarningDepot from '@/views/components/warning/WarningDepot.vue';
import MeitiTypeWarning from '@/components/MeitiTypeWarning.vue';
import WarningDetailsPage from '@/views/components/warning/WarningDetailsPage.vue';
import ReportNews from '@/views/components/monitoring/ReportNews.vue';
import warningApi from '@/api/warning';
import reportApi from '@/api/report';
import exportApi from '@/api/export';
import jiaobanDialog from './components/jiaobanDialog'

export default {
	components: {
		EarlyTime,
		FilterStatus,
		MeitiType2,
		WarningDepot,
		MeitiTypeWarning,
		WarningDetailsPage,
		ReportNews,
		jiaobanDialog
	},
	computed: {
		rightFixedbottom() {
			return this.$store.state.rightFixedbottom;
		},
		ifBack() {
			return this.$store.state.ifBack;
		}
	},
	mounted() {
		if (this.$route.query.pageId) {
			this.pageId = this.$route.query.pageId;
		}
		this.query2 = JSON.parse(JSON.stringify(this.query));
		this.getList();
		this.getHotnewsProvince();
		this.getHotnewsCountry();
		this.getDataPageOnce();
	},
	beforeDestroy() {
		if (this.timer) {
			clearTimeout(this.timer);
		}

	},
	data() {
		return {
		    query:{
                pageNo: 1,
                pageSize: 20,
                days: '7',
                startDate: null,
                endDate: null,
                key: '',
                area: '',
                sourceType: '1,2,3,4,8,9,10',
                sort: 3,
                deleted: 0
			},
			query2:{
				pageNo: 1,
				pageSize: 20,
				days: '7',
				startDate: null,
				endDate: null,
				key: '',
				area: '',
				sourceType: '1,2,3,4,8,9,10',
				sort: 3,
				deleted: 0
			},
			checkedAll: false,
            inputkey2: '',
			total: 0,
			provinceNewsList: [],
			countryNewsList: [],
			meitis: [
				{
					uuid: '',
					name: '全部'
				},
				{
					uuid: '0',
					name: '属地'
				},
				{
					uuid: '1',
					name: '非属地'
				}
			],
			paixus: [
				{
					uuid: '3',
					name: '时间降序'
				},
				{
					uuid: '4',
					name: '时间升序'
				}
			],
			yuqingList: [],
			selectedsList: [], //选中的数组
			isPass: false,
			selectedListitem: {}, //操作的选项
            meitiCheckList:['1','2','3','4','8','9','10'],
			totalPage: 0,
			dataloading: true,
			index: 'warn_jiance',
			detailsPageFlag: false,
			pageId: '0', //0舆情列表1相同文章2查看正文,
			timer: null,
			haveNews: false,
			newsPropsTimer:null,
			newsNum:0,
			showJBdialog:false,
		};
	},
	created() {
		//this.getHaveNews();
		// let custId=this.$cookies.get('userInfo').custId
	},
	destroyed(){
		clearTimeout(this.newsPropsTimer)
	},
	methods: {
		//监测时间 改变的
		changeTime(obj) {
			//点击时间
			this.startDate = null;
			this.endDate = null;
			this.query.days = obj.type;
			if (parseInt(obj.type) == 0) {
				if (obj.val != null && obj.val.length > 0) {
					this.query.startDate = this.$moment(new Date(obj.val[0])).format('YYYY-MM-DD HH:mm:ss');
					this.query.endDate = this.$moment(new Date(obj.val[1])).format('YYYY-MM-DD HH:mm:ss');
				}
			}
		},
		//媒体地域 的值
		changemeiti(obj) {
			this.query.area = obj.type;
		},
		changepaixu(obj) {
			this.query.sort = obj.type;
		},
		changeMeitiType(obj) {
            this.meitiCheckList = obj;
			this.query.sourceType = obj.join(',');
		},
		showToolTipProp2(tips) {
			this.$refs.toolTipProp2.show(tips);
		},
		//确认提示框 成功后的 函数
		confirmSucess(obj) {
			if (obj === 'ok') {
				eval(`this.${this.fnStr}()`);
			}
		},
		showConfirmProp2(tips) {
			this.$refs.confirmProp2.show(tips);
		},
		showClosedProp2(tips) {
			this.$refs.closedProp2.show(tips);
		},
		//全选操作
		checkedAllChange() {
			this.yuqingList.forEach(item => {
				item.ischeckd = this.checkedAll;
			});
		},
		//获取选中的
		getSelectedsList() {
			this.selectedsList = [];
			this.selectedsList = this.yuqingList.filter(item => {
				return item.ischeckd;
			});
			if (this.selectedsList.length === 0) {
				this.showToolTipProp2('请选择要操作的数据');
				return false;
			} else {
				return this.selectedsList;
			}
		},
		//批量导出
		batchExport() {
			if (!this.getSelectedsList()) {
				return;
			}

			let that = this;

			let ids = this.getSelectedsList().map(item => {
				return item.id;
			});

			let data = {
				ids: ids.join()
			};

			that.$my_confirm('确定要导出选中的数据么？', {
				yesBtnText: '确 定', //确定按钮的文字
				cancelBtnText: '取 消', //取消按钮的文字
				type: 'question', //
				isShowCancelBtn: true //是否显示取消按钮
			})
				.then(() => {
					const loading = this.$loading({
						lock: true,
						text: '正在生成文件，请稍等。',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					exportApi.warn(data).then(res => {
						let url = '/jiance/file/' + res.returnData.url;
						window.open(url, '_blank');
						loading.close();
					});
				})
				.catch(() => {});
		},
		batchExportPost() {
			this.showClosedProp2('导出成功');
		},
		//全部导出
		allExport() {
			let that = this;
			that.$my_confirm('全部导出，最多导出近1000条，确定要导出数据么？', {
				yesBtnText: '确 定', //确定按钮的文字
				cancelBtnText: '取 消', //取消按钮的文字
				type: 'question', //
				isShowCancelBtn: true //是否显示取消按钮
			})
				.then(() => {
					const loading = this.$loading({
						lock: true,
						text: '正在生成文件，请稍等。',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					exportApi.warn(this.query2).then(res => {
						let url = '/jiance/file/' + res.returnData.url;
						window.open(url, '_blank');
						loading.close();
					});
				})
				.catch(() => {});
		},
		//全部导出请求
		allExportPost() {
			this.showClosedProp2('全部导出成功');
		},
		//批量删除
		batchDel() {
			if (this.getSelectedsList()) {
				this.fnStr = 'batchDelPost';
				this.showConfirmProp2('确定要删除选中的数据么？');
			}
		},
		batchDelPost() {
			let _this = this;
			let ids = [];
			let index = this.selectedsList.findIndex(item => {
				ids.push(item.id);
			});
			let data = {
				deleted: 1,
				all: 0,
				index: 'warn_jiance',
				ids: ids.join(',')
			};
			warningApi.bulkData(data).then(res => {
				if (res.returnCode === '1001') {
					_this.checkedAll = false;
					ids.forEach(item => {
						let index = this.yuqingList.findIndex(item2 => {
							return item2.id === item;
						});
						_this.yuqingList.splice(index, 1);
						if (_this.yuqingList.length == 0) {
							if (_this.currentPage != 1) {
								_this.currentPage--;
							}
							_this.getList();
						}
					});
                    //_this.getList();
					this.checkedAll = false;
					_this.showClosedProp2('删除成功');
				}
			});
		},
		//查看正文
		detailContent(item) {
			let query = JSON.parse(JSON.stringify(this.query2));
			let dTime = new Date().getTime();
			query.id = item.id;
			query.dTime = dTime;
			//存入需要带到新窗口的内容
			window.sessionStorage.setItem(dTime + '', JSON.stringify(query));
			//跳转到 另一页
			let routerdata = this.$router.resolve({
				name: 'earlyWarning', //此name就是基金对比页面path的name,在router里边配好的该页面的名字，这样直接就可以匹配到该页面的路径
				query: {
					//没有这个 先传个0
					thmeId: '0',
					pageId: '2', //跳转系统详情页
					dTime: dTime //此页面的唯一标识
				}
			});
			let newhref = routerdata.href;
			window.open(newhref, '_blank');
		},
		//复制
		copy(item, t) {
			let that = this;
			let text = '';
			if (t == 2) {
				text = item.url;
			} else {
				text = '标题：' + item.title + '\n链接：' + item.url + '\n时间：' + item.pageTime + '\n来源：' + item.websiteName;
			}
			this.$copyText(text).then(
				function(e) {
					that.$refs.closedProp2.show('内容已复制到剪切板！');
					// that.$message.success('内容已复制到剪切板！');
				},
				function(e) {
					that.$refs.closedProp2.show('抱歉，复制失败！');
					//that.$message.error('抱歉，复制失败！');
				}
			);
		},
		//舆情上报
		singlepublicReport(item) {
			let _this = this;
			this.selectedListitem = item;
			reportApi.checkUrl({ url: item.url }).then(res => {
				if (res.returnCode == '100') {
					if(res.returnData.returnFlag == 1){
						//判断是否达上限 等于1 就是达上限了
						_this.$my_confirm(res.returnData.returnFlagMsg, {
							yesBtnText: '确定',
							type: 'tips'
						});
						return false
					}
					if (res.returnData.flag == 0) {
						_this.$refs.reportNews.initData(item);
						_this.$refs.reportNews.show();
					} else {
						_this.showToolTipProp2('该舆情已报送，请不要重复上报!');
					}
				} else {
					_this.showToolTipProp2(res.returnMsg);
				}
			});
		},
		singlepublicReportClose() {
			let _this = this;
			_this.showToolTipProp2('报送成功!');
		},
		singlepublicReportPost() {
			this.$refs.reportLoading.show();
		},
		//标星
		biaoxing(num, item) {
			let _this = this;
			for (let it of this.yuqingList) {
				if (it.id === item.id) {
					it.warnDegree = num;
					_this.btnBiaoXing(num, item);
					return false;
				}
			}
		},
		btnBiaoXing(num, item) {
			let _this = this;
			let data = {
				index: _this.index,
				all: '0',
				ids: item.id,
				warnDegree: num
			};
			warningApi.bulkData(data).then(res => {
				if (res.returnCode === '1001') {
					_this.showClosedProp2('操作成功');
				}
			});
		},
		singleDel(item) {
			this.selectedListitem = item;
			this.fnStr = 'singleDelPost';
			this.showConfirmProp2('确定要删除选中的数据么？');
		},
		singleDelPost() {
			let _this = this;
			let data = {
				deleted: 1,
				all: 0,
				index: _this.index,
				ids: _this.selectedListitem.id
			};
			warningApi.bulkData(data).then(res => {
				if (res.returnCode === '1001') {
					let index = this.yuqingList.findIndex(item => {
						return item.id === _this.selectedListitem.id;
					});
					_this.yuqingList.splice(index, 1);
					if (_this.yuqingList.length == 0) {
						if (_this.currentPage != 1) {
							_this.currentPage--;
						}
						this.checkedAll = false;
						_this.getList();
					}
                    //_this.getList();
					_this.showClosedProp2('删除成功');
					_this.total = _this.total -1
				}
			});
		},
		//单选改变时改变全选状态
		singelChecked() {
			let checked = true;
			for (let it of this.yuqingList) {
				if (!it.ischeckd) {
					checked = false;
				}
			}
			this.checkedAll = checked;
		},
		//回收站
		collectionDepot() {
			this.$refs.warningDepot.show();
			this.$refs.warningDepot.searchData();
		},
		getHotnewsProvince() {
			let _this = this;
			warningApi.hotNews({ provinceId: 1 }).then(res => {
				if (res.returnCode == '1001') {
					_this.provinceNewsList = res.returnData;
				}
			});
		},
		getHotnewsCountry() {
			let _this = this;
			warningApi.hotNews({ provinceId: 0 }).then(res => {
				if (res.returnCode == '1001') {
					_this.countryNewsList = res.returnData;
				}
			});
		},
		getList() {
			let _this = this;
			_this.dataloading = true;
			this.hideNewsProps(2)
			this.timer = setTimeout(function() {
				_this.yuqingList = [];
                _this.query2.pageNo = _this.query.pageNo;
				warningApi.list(_this.query2).then(res => {
					_this.dataloading = false;
					_this.inputkey2 = _this.query2.key;
                    _this.query = JSON.parse(JSON.stringify(_this.query2));
                    if(_this.query2.sourceType) {
                        _this.meitiCheckList = _this.query2.sourceType.split(",");
                    }
					if (res.returnCode == '1001') {
						if (res.returnData.data != null && res.returnData.data.length > 0) {
							res.returnData.data.forEach(item => {
								item.contentTag = _this.$utils.handleText(item.contentTag);
								item.titleTag = _this.$utils.handleText(item.titleTag);
								if (item.contentTag == undefined) {
									item.contentTag = item.content;
								}
								if (item.titleTag == undefined) {
									item.titleTag = item.title;
								}
								item.ischeckd = false;
							});
						}
						let rst = res.returnData.data;
						_this.yuqingList = rst;
						_this.total = res.returnData.total;
						_this.totalPage = res.returnData.totalPage;
					} else {
						_this.$refs.warningProp.show('数据异常!');
					}
				});
			}, 200);
		},
		handleCurrentChange(val) {
            this.checkedAll=false
			this.query.pageNo = val;
			this.getList();
		},
		clickPrevious() {
			if (this.query.pageNo != 1) {
                this.checkedAll=false
				this.query.pageNo--;
				this.getList();
			} else {
				this.$refs.warningProp.show('已经是第一页了');
			}
		},
		clickNext() {
			if (this.query.pageNo < this.totalPage) {
                this.checkedAll=false
				this.query.pageNo++;
				this.getList();
			} else {
				this.$refs.warningProp.show('没有最后一页了');
			}
		},
		filterSearch(){
            this.checkedAll=false
            this.yuqingList = [];
            this.query.pageNo = 1;
            this.query2 = JSON.parse(JSON.stringify(this.query));
            this.getList();
		},
		btnSearch() {
		    this.query.key = this.inputkey2;
            this.checkedAll=false
			this.yuqingList = [];
			this.query.pageNo = 1;
            this.query2 = JSON.parse(JSON.stringify(this.query));
			this.getList();
		},
		showProps() {
			this.haveNews = true;
		},
		hideNewsProps(num) {
			// console.log('隐藏更新弹窗  获取最新媒体值 当页码为1时获取 时间值')
			this.haveNews = false;
			if (num !== 2) {
				//当是通过点击 搜索来更新的时候  不用重复调用此两个函数
				this.getList();
			}
			if(this.query.pageNo === 1){
				this.getDataPageOnce();
			}
			
		},
		//获取 新的数据条数
		getHaveNews: async function() {
			// console.log('获取 新的数据条数')
			let data = JSON.parse(JSON.stringify(this.query2))
            data.pageSize = 1;
            data.startDate = this.endId;
			
			let res = await  warningApi.list(data);
			//每60秒 获取一次
			//有新的数据 就
			// console.log('getHaveNews');
			// console.log(res);
			let that = this;
			if(res.returnCode === "1001"){
				if(parseInt(res.returnData.total) > 0){
					this.newsNum = res.returnData.total
					// console.log(this.newsNum)
					//当查询页码等于1 且 时间等于降序的时候  才弹出这个框
					if(this.query2.pageNo === 1 && this.query2.sort === 3){
						this.showProps();
					}
				}
			}
			if(this.newsPropsTimer){
				clearTimeout(this.newsPropsTimer);
				this.newsPropsTimer = null
			}
			this.newsPropsTimer = setTimeout(() => {
				that.getHaveNews();
			}, 60000);
		},
		//页面初始化调用 及  点击更新信息时调用
		getDataPageOnce: async function() {
			// console.log('获取最新的dres.returnData.result[0].pageTime')
            let data = JSON.parse(JSON.stringify(this.query2))
            data.pageSize = 1;
            data.startDate = this.endId;

			let res = await warningApi.list(data);
			if(res.returnCode !== "1001"){
				this.getDataPageOnce()
				return false
			}
			// console.log(res)
			if(res.returnData.data.length > 0){
				//this.endId = res.returnData.result[0].pageTime
				// console.log(res.returnData.data[0].pageTime);

				var myDate = new Date(res.returnData.data[0].pageTime);
				myDate.setSeconds(myDate.getSeconds() + 10);//添加一秒钟
				 this.endId =  this.$moment(myDate).format('YYYY-MM-DD HH:mm:ss')
			}
			//this.endId  = res.returnData.nowMaxId
			// console.log(this.endId)
			if(this.newsPropsTimer){
				clearTimeout(this.newsPropsTimer);
				this.newsPropsTimer = null
			}
			let that = this;
			 this.newsPropsTimer =setTimeout(() => {
				that.getHaveNews();
			}, 60000);
		},
		jiaoban(item){
			// console.log(item)
			// warningApi.hasJiaoban({yqUrl:item.url&&item.url.length>0?item.url:''}).then(res=>{
			// 	console.log(res)
			// })
			warningApi.hasJiaoban({yqUrl:item.url&&item.url.length>0?item.url:''}).then(res=>{
				// console.log(res)
				if(res.returnCode==100){
					this.showJBdialog=true
					this.$nextTick(()=>{
					    this.$refs.jiaobanRef.id=item.id
					    this.$refs.jiaobanRef.form.title=item.title
					    this.$refs.jiaobanRef.form.yqUrl=item.url
					    this.$refs.jiaobanRef.form.yqContent=item.content
					})
				}else{
					this._notice(res.returnMsg,'warning')
				}
			})
        },
		dialogClose(){
            this.showJBdialog=false
		},
		_notice(message,type){
			this.$message({message,type});
		},
	}
};
</script>

<style lang="less">
@import '../../assets/css/page/earlyWarning/earlyWarning.less';

.earlyWarning .layout-div .layout-left-div .layout-left-bottom .listul .lis .lisrow .newInfos .iconimg.pxdz .fuzhi {
	width: 200px;
}

.timePublic .lisitems .dashLine {
	border-bottom: 0px dashed #999999;
}
</style>
